import React, { useEffect, useState } from "react";

import {
  useNavigate,
  useLocation,
} from "react-router-dom";

import { db } from "../firebase";

import {
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";

import {
  FaArrowLeft,
  FaMobileAlt,
  FaBuilding,
  FaCopy,
  FaCheckCircle,
  FaWallet,
  FaClock,
  FaMoneyBillWave,
  FaShieldAlt,
} from "react-icons/fa";

import "./BFCOtherCountryConfirmed.css";


export default function MobilePayment() {

  const navigate = useNavigate();

  const { state } = useLocation();


  /* =========================================================
     PAYMENT DATA
  ========================================================= */

  const provider =
    state?.provider || "";

  const amount =
    state?.amount || "";

  const country =
    state?.country ||
    state?.countryName ||
    state?.country?.name ||
    "Tanzania";

  const currency =
    state?.currency ||
    state?.country?.currency ||
    "TZS";

  const rate =
    Number(
      state?.rate || 0
    );

  const receiveAmount =
    Number(
      state?.receiveAmount || 0
    );

  const receiveCurrency =
    state?.receiveCurrency ||
    "USDT";

  const minimumAmount =
    Number(
      state?.minimumAmount || 0
    );

  const flag =
    state?.flag ||
    state?.country?.flag ||
    "";


  /* =========================================================
     ACCOUNT TYPE
  ========================================================= */

  const [accountType, setAccountType] =
    useState("normal");


  /* =========================================================
     ACCOUNTS
  ========================================================= */

  const [currentNormal, setCurrentNormal] =
    useState(null);

  const [currentBusiness, setCurrentBusiness] =
    useState(null);


  /* =========================================================
     COPY STATE
  ========================================================= */

  const [copied, setCopied] =
    useState(false);


  /* =========================================================
     FIRESTORE COLLECTIONS
  ========================================================= */

  const normalRef =
    collection(
      db,
      "normalNumbers"
    );

  const businessRef =
    collection(
      db,
      "depositNumbers"
    );


  /* =========================================================
     FIREBASE PROVIDER
  ========================================================= */

  const firebaseProvider =
    provider.includes("Vodacom")
      ? "Vodacom"
      : provider.includes("Airtel")
      ? "Airtel"
      : provider.includes("Yas")
      ? "Tigo"
      : "Halotel";


  /* =========================================================
     COPY TEXT
  ========================================================= */

  const copyText = async (text) => {

    if (!text) {
      return;
    }


    try {

      setCopied(false);


      const value =
        String(text);


      /* =====================================================
         MODERN CLIPBOARD
      ===================================================== */

      if (
        navigator.clipboard &&
        window.isSecureContext
      ) {

        await navigator.clipboard.writeText(
          value
        );

      }


      /* =====================================================
         MOBILE FALLBACK
      ===================================================== */

      else {

        const textArea =
          document.createElement(
            "textarea"
          );


        textArea.value =
          value;


        textArea.style.position =
          "fixed";

        textArea.style.left =
          "-9999px";

        textArea.style.top =
          "0";

        textArea.style.width =
          "1px";

        textArea.style.height =
          "1px";

        textArea.style.opacity =
          "0";

        textArea.style.pointerEvents =
          "none";

        textArea.setAttribute(
          "readonly",
          ""
        );


        document.body.appendChild(
          textArea
        );


        textArea.focus();

        textArea.select();


        textArea.setSelectionRange(
          0,
          value.length
        );


        const successful =
          document.execCommand(
            "copy"
          );


        document.body.removeChild(
          textArea
        );


        if (!successful) {

          throw new Error(
            "Copy command failed"
          );

        }

      }


      setCopied(true);


      setTimeout(() => {

        setCopied(false);

      }, 2200);

    }

    catch (error) {

      console.error(
        "Copy failed:",
        error
      );


      alert(
        "Failed to copy. Please try again."
      );

    }

  };


  /* =========================================================
     FIREBASE REALTIME LISTENER
  ========================================================= */

  useEffect(() => {

    const normalQuery =
      query(
        normalRef,
        where(
          "provider",
          "==",
          firebaseProvider
        )
      );


    const businessQuery =
      query(
        businessRef,
        where(
          "provider",
          "==",
          firebaseProvider
        )
      );


    /* =======================================================
       NORMAL ACCOUNT
    ======================================================= */

    const unsubscribeNormal =
      onSnapshot(
        normalQuery,

        (snapshot) => {

          const list =
            snapshot.docs.map(
              (item) => ({

                id:
                  item.id,

                ...item.data(),

              })
            );


          if (
            list.length > 0
          ) {

            const randomIndex =
              Math.floor(
                Math.random() *
                list.length
              );


            setCurrentNormal(
              list[randomIndex]
            );

          }

          else {

            setCurrentNormal(
              null
            );

          }

        },

        (error) => {

          console.error(
            "Normal account error:",
            error
          );


          setCurrentNormal(
            null
          );

        }
      );


    /* =======================================================
       BUSINESS ACCOUNT
    ======================================================= */

    const unsubscribeBusiness =
      onSnapshot(
        businessQuery,

        (snapshot) => {

          const list =
            snapshot.docs.map(
              (item) => ({

                id:
                  item.id,

                ...item.data(),

              })
            );


          if (
            list.length > 0
          ) {

            const randomIndex =
              Math.floor(
                Math.random() *
                list.length
              );


            setCurrentBusiness(
              list[randomIndex]
            );

          }

          else {

            setCurrentBusiness(
              null
            );

          }

        },

        (error) => {

          console.error(
            "Business account error:",
            error
          );


          setCurrentBusiness(
            null
          );

        }
      );


    /* =======================================================
       CLEANUP
    ======================================================= */

    return () => {

      unsubscribeNormal();

      unsubscribeBusiness();

    };

  }, [firebaseProvider]);


  /* =========================================================
     CURRENT ACCOUNT
  ========================================================= */

  const currentAccount =
    accountType === "normal"
      ? currentNormal
      : currentBusiness;


  /* =========================================================
     CHECK TANZANIA
  ========================================================= */

  const isTanzania =
    String(country)
      .trim()
      .toLowerCase() ===
    "tanzania";


  /* =========================================================
     COMPLETE PAYMENT
  ========================================================= */

  const handleComplete = () => {

    /* =====================================================
       NO ACCOUNT
    ===================================================== */

    if (!currentAccount) {

      alert(
        "Wait Payment Account"
      );

      return;

    }


    /* =====================================================
       TANZANIA
       
       Tanzania inaendelea kutumia
       confirmation page yake ya zamani.
    ===================================================== */

    if (isTanzania) {

      navigate(
        "/confirm-deposits",
        {
          state: {

            provider,

            amount,

            accountType,

            number:
              currentAccount.number,

            fullname:
              currentAccount.fullname,

          },
        }
      );

      return;

    }


    /* =====================================================
       OTHER COUNTRIES
       
       Nchi zote nyingine zinaenda
       OtherCountryConfirmed.
    ===================================================== */

    navigate(
      "/other-country-confirmed",
      {
        state: {

          deposit: {

            /* =========================
               USER
            ========================= */

            username:
              localStorage.getItem(
                "username"
              ) || "Guest",


            /* =========================
               COUNTRY
            ========================= */

            countryName:
              country,

            flag:
              flag,


            /* =========================
               CURRENCY
            ========================= */

            currency:
              currency,


            /* =========================
               AMOUNT
            ========================= */

            amount:
              Number(amount) || 0,

            minimumAmount:
              minimumAmount,


            /* =========================
               RATE
            ========================= */

            rate:
              rate,


            /* =========================
               RECEIVE
            ========================= */

            receiveAmount:
              receiveAmount,

            receiveCurrency:
              receiveCurrency,


            /* =========================
               PAYMENT
            ========================= */

            paymentMethod:
              provider,


            /* =========================
               ACCOUNT
            ========================= */

            paymentAccountType:
              accountType,

            receivingNumber:
              currentAccount.number,

            receivingName:
              currentAccount.fullname,


            /* =========================
               OPTIONAL
            ========================= */

            excludeVerification:
              false,

          },

        },

      }
    );

  };


  /* =========================================================
     UI
  ========================================================= */

  return (

    <div
      className="mobile-payment-page"
    >


      {/* =====================================================
          BACK BUTTON
      ===================================================== */}

      <button
        type="button"
        className="payment-back-btn"
        onClick={() =>
          navigate(-1)
        }
      >

        <FaArrowLeft />

        <span>
          Back
        </span>

      </button>


      {/* =====================================================
          MAIN CONTAINER
      ===================================================== */}

      <div
        className="mobile-payment-container"
      >


        {/* ===================================================
            HEADER
        =================================================== */}

        <div
          className="payment-header"
        >

          <div
            className="payment-header-content"
          >

            <span
              className="payment-badge"
            >

              MOBILE PAYMENT

            </span>


            <h1>

              Complete Deposit

            </h1>


            <p>

              Send the exact amount to the
              payment account below.

            </p>


          </div>


          <div
            className="payment-security-icon"
          >

            <FaShieldAlt />

          </div>

        </div>


        {/* ===================================================
            PAYMENT SUMMARY
        =================================================== */}

        <div
          className="payment-summary"
        >


          {/* PROVIDER */}

          <div
            className="summary-card"
          >

            <div
              className="summary-icon"
            >

              <FaMobileAlt />

            </div>


            <div>

              <span>
                PAYMENT METHOD
              </span>


              <strong>

                {provider ||
                  "Mobile Money"}

              </strong>

            </div>

          </div>


          {/* AMOUNT */}

          <div
            className="summary-card amount-card"
          >

            <div
              className="summary-icon"
            >

              <FaMoneyBillWave />

            </div>


            <div>

              <span>
                DEPOSIT AMOUNT
              </span>


              <strong>

                {
                  amount ||
                  "0"
                }{" "}

                {currency}

              </strong>

            </div>

          </div>

        </div>


        {/* ===================================================
            ACCOUNT SECTION
        =================================================== */}

        <div
          className="payment-section"
        >


          {/* SECTION HEADING */}

          <div
            className="section-heading"
          >

            <div>

              <span>
                PAYMENT ACCOUNT
              </span>


              <h2>
                Choose Account
              </h2>

            </div>

          </div>


          {/* =================================================
              ACCOUNT TABS
          ================================================= */}

          <div
            className="account-tabs"
          >


            {/* NORMAL */}

            <button
              type="button"
              className={
                accountType === "normal"
                  ? "active"
                  : ""
              }
              onClick={() => {

                setAccountType(
                  "normal"
                );

                setCopied(false);

              }}
            >

              <FaMobileAlt />

              <span>
                Normal Number
              </span>

            </button>


            {/* BUSINESS */}

            <button
              type="button"
              className={
                accountType === "business"
                  ? "active"
                  : ""
              }
              onClick={() => {

                setAccountType(
                  "business"
                );

                setCopied(false);

              }}
            >

              <FaBuilding />

              <span>
                Business Account
              </span>

            </button>

          </div>


          {/* =================================================
              ACCOUNT
          ================================================= */}

          {currentAccount ? (

            <div
              className="number-box"
            >


              {/* ACCOUNT TYPE */}

              <div
                className="account-label"
              >

                <span>

                  {
                    accountType === "normal"
                      ? "NORMAL MOBILE NUMBER"
                      : "BUSINESS ACCOUNT"
                  }

                </span>


                <FaCheckCircle />

              </div>


              {/* PHONE NUMBER */}

              <div
                className="account-row"
              >

                <div
                  className="row-icon"
                >

                  <FaMobileAlt />

                </div>


                <div
                  className="account-info"
                >

                  <span>
                    PHONE NUMBER
                  </span>


                  <strong>

                    {
                      currentAccount.number
                    }

                  </strong>

                </div>


                {/* COPY */}

                <button
                  type="button"
                  className={
                    copied
                      ? "copy-btn copied"
                      : "copy-btn"
                  }
                  onClick={() =>
                    copyText(
                      currentAccount.number
                    )
                  }
                  aria-label={
                    copied
                      ? "Number copied"
                      : "Copy phone number"
                  }
                >

                  {copied ? (

                    <>

                      <FaCheckCircle />

                      <span>
                        Copied
                      </span>

                    </>

                  ) : (

                    <>

                      <FaCopy />

                      <span>
                        Copy
                      </span>

                    </>

                  )}

                </button>

              </div>


              {/* ACCOUNT NAME */}

              <div
                className="account-row"
              >

                <div
                  className="row-icon"
                >

                  <FaWallet />

                </div>


                <div
                  className="account-info"
                >

                  <span>
                    ACCOUNT NAME
                  </span>


                  <strong>

                    {
                      currentAccount.fullname
                    }

                  </strong>

                </div>

              </div>

            </div>

          ) : (

            /* =================================================
               NO ACCOUNT
            ================================================= */

            <div
              className="no-account-box"
            >

              <div
                className="no-account-icon"
              >

                !

              </div>


              <h3>

                No Account Available

              </h3>


              <p>

                There is currently no
                payment account available
                for {provider}.

              </p>

            </div>

          )}


          {/* =================================================
              PAYMENT INSTRUCTION
          ================================================= */}

          <div
            className="payment-note"
          >

            <div
              className="note-icon"
            >

              <FaMoneyBillWave />

            </div>


            <div
              className="note-content"
            >

              <span>

                PAYMENT INSTRUCTION

              </span>


              <p>

                Please send exactly{" "}

                <strong>

                  {
                    amount ||
                    "0"
                  }{" "}

                  {currency}

                </strong>

                {" "}to the account shown
                above.

              </p>


              <small>

                After completing the payment,
                press the button below to
                continue.

              </small>

            </div>

          </div>


          {/* =================================================
              PAYMENT STATUS
          ================================================= */}

          <div
            className="payment-status"
          >

            <div>

              <FaCheckCircle />

              <span>
                Secure Payment
              </span>

            </div>


            <div>

              <FaClock />

              <span>
                Processing Time: Instant
              </span>

            </div>

          </div>


          {/* =================================================
              COMPLETE BUTTON
          ================================================= */}

          <button
            type="button"
            className="continue-btn"
            onClick={
              handleComplete
            }
          >

            <span>

              Complete Payment

            </span>


            <FaArrowLeft
              className="continue-arrow"
            />

          </button>


        </div>

      </div>

    </div>

  );

}